import type {ReactElement} from 'react';
import React from 'react';
import {DigitalSignageOption} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/publishing-digital-signage-list.types';
import type {PublishingSignageLivePanelProps} from './publishing-signage-live-panel.types';
import {DigitalSignageSubPanel} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-sub-panel/digital-signage-sub-panel';
import {useProductUsed} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel-library';
import {usePosterPageHashedId} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.hooks';

export function PublishingSignageLivePanel({...props}: PublishingSignageLivePanelProps): ReactElement<any> {
  const productUsed = useProductUsed();
  const pageHashedId = usePosterPageHashedId();
  const pageOrderId = productUsed?.existingPageOrders?.[pageHashedId] ?? productUsed?.orderId ?? '';
  const onDownloadSignageWidget = (): void => {
    if (pageOrderId === '') {
      return;
    }
    void window.PMW.writeLocal('cart/addOrderUsedByDigitalSignage', {
      orderId: pageOrderId,
      type: DigitalSignageOption.SIGNAGE_LIVE,
    });
    window.location.href = window.PMW.util.site_url(`cart/prepSignageLiveWidgetDownload?id=${pageOrderId}&t=${new Date().getTime()}`);
  };

  return (
    <DigitalSignageSubPanel
      panelHeading={window.i18next.t('pmwjs_signagelive')}
      heading={window.i18next.t('pmwjs_signagelive_widget')}
      subheading={window.i18next.t('pmwjs_signagelive_desc')}
      showButton
      onClose={props.onClose}
      buttonText={window.i18next.t('pmwjs_download_widget')}
      onClick={onDownloadSignageWidget}
      imgSrc="publishing-signagelive.png"
    />
  );
}
